/* opus-capture.js (4 Oct 2026): the footer sign-up box feeds Klaviyo's main email list,
   the list the Klaviyo pop-up (form SiNTAh) feeds. Public key X7tfv2, list XpXgJ5.
   Client subscriptions API, public key only (never a private key here).
   Loaded once from layout/opus.liquid. Works on every form[data-capture-form]. */
(function () {
  'use strict';
  var COMPANY = 'X7tfv2';
  var LIST = 'XpXgJ5';
  var URL = 'https://a.klaviyo.com/client/subscriptions?company_id=' + COMPANY;
  var REVISION = '2026-07-15';
  var RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var d = document;

  function style() {
    if (d.getElementById('opus-capture-css')) return;
    var s = d.createElement('style');
    s.id = 'opus-capture-css';
    s.textContent = '.capture__err{margin:0;width:100%;font-size:var(--t-small);font-weight:600;color:#b3261e}' +
      '.sfoot .capture__err{color:#ffb4ab}' +
      '.capture input[aria-invalid=true]{border-color:#b3261e;box-shadow:0 0 0 1px #b3261e}' +
      '.sfoot .capture input[aria-invalid=true]{border-color:#ffb4ab;box-shadow:0 0 0 1px #ffb4ab}' +
      '.capture button[aria-busy=true]{opacity:.7;cursor:progress}';
    d.head.appendChild(s);
  }

  function errFor(form, input) {
    var id = (input.id || 'cap') + '-err';
    var p = d.getElementById(id);
    if (!p) {
      p = d.createElement('p');
      p.id = id;
      p.className = 'capture__err';
      p.setAttribute('role', 'alert');
      p.hidden = true;
      form.appendChild(p);
    }
    return p;
  }

  function showErr(form, input, msg) {
    var p = errFor(form, input);
    p.textContent = msg;
    p.hidden = false;
    input.setAttribute('aria-invalid', 'true');
    // keep the input's own description (the footer input points at its Follow line) and add the error
    // (shared layer, 5 Oct 2026, 11:15pm Pacific); an input with none gets the error alone, as before
    var base = input.hasAttribute('data-desc') ? input.getAttribute('data-desc') : (input.getAttribute('aria-describedby') || '');
    input.setAttribute('data-desc', base);
    input.setAttribute('aria-describedby', (base + ' ' + p.id).trim());
    input.focus();
  }

  function clearErr(form, input) {
    var p = d.getElementById((input.id || 'cap') + '-err');
    if (p) { p.hidden = true; p.textContent = ''; }
    input.removeAttribute('aria-invalid');
    if (!input.hasAttribute('data-desc')) return; // no error shown yet: its own description stays as it is
    var base = input.getAttribute('data-desc');
    if (base) input.setAttribute('aria-describedby', base); else input.removeAttribute('aria-describedby');
  }

  function done(form, box) {
    var ok = box && box.querySelector('.capture__ok');
    form.hidden = true;
    form.style.display = 'none';
    if (ok) {
      ok.hidden = false;
      ok.setAttribute('tabindex', '-1');
      ok.focus();
    }
  }

  /* Klaviyo "Form submitted by profile", so a footer sign-up starts the welcome emails
     (welcome flow X5yXrA starts from this event; its trigger lists form_id "opus-footer").
     Sent only after the subscribe call succeeded; never blocks or changes what the reader sees.
     Sign-ups session, 5 Oct 2026: MIKE/SITE-SIGNUPS-AND-POPUPS/SITE-CHANGES-FOR-SITE-SESSION.md */
  function opusFormEvent(email, where){
    try{
      fetch('https://a.klaviyo.com/client/events/?company_id=X7tfv2',{
        method:'POST', keepalive:true,
        headers:{'content-type':'application/vnd.api+json', revision:'2024-10-15'},
        body:JSON.stringify({data:{type:'event',attributes:{
          properties:{form_id:'opus-footer', form_name:'opus.life footer sign-up', form_type:'embed', where:where||'footer', page:location.href},
          metric:{data:{type:'metric',attributes:{name:'Form submitted by profile'}}},
          profile:{data:{type:'profile',attributes:{email:email}}}
        }}})
      }).catch(function(){});
    }catch(x){}
  }

  d.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-capture-form]')) return;
    e.preventDefault();
    var input = form.querySelector('input[type=email]');
    if (!input) return;
    var btn = form.querySelector('button[type=submit],button:not([type])');
    var box = form.closest('.capture');
    var email = String(input.value || '').trim();
    style();
    if (!RE.test(email)) {
      showErr(form, input, 'That email doesn\'t look right. Check for a typo and try again.');
      return;
    }
    clearErr(form, input);
    if (form.getAttribute('data-sending') === '1') return;
    form.setAttribute('data-sending', '1');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var where = (box && box.getAttribute('data-capture')) || 'footer';
    /* ON-236 (24 Oct 2026): the Meta ad clicks this browser made (snippets/opus-ad-path), on the profile, when there are any */
    var ap = null;
    try { ap = window.opusAdPath && window.opusAdPath.props(); } catch (x) {}
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'opus.life ' + where,
          profile: { data: { type: 'profile', attributes: {
            email: email,
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
          } } }
        },
        relationships: { list: { data: { type: 'list', id: LIST } } }
      }
    };
    if (ap) body.data.attributes.profile.data.attributes.properties = ap;
    fetch(URL, {
      method: 'POST',
      headers: { 'content-type': 'application/vnd.api+json', revision: REVISION },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('status ' + r.status);
      opusFormEvent(email, where);
      try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (x) {}
      done(form, box);
    }).catch(function () {
      showErr(form, input, 'We couldn\'t sign you up just now. Please try again in a minute.');
    }).then(function () {
      form.removeAttribute('data-sending');
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    });
  });

  d.addEventListener('input', function (e) {
    var input = e.target;
    if (input && input.getAttribute && input.getAttribute('aria-invalid') === 'true' && input.form && input.form.matches('form[data-capture-form]')) {
      clearErr(input.form, input);
    }
  });
})();
